import { ThreeDots } from "react-loader-spinner";

const radio = ({ fill = "white", onClick = () => {}, ...props }) => (
  <svg
    {...props}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle
      cx="10"
      cy="10"
      r="9.75"
      fill={fill}
      stroke="black"
      strokeWidth="0.5"
    />
  </svg>
);

const radio2 = ({ success, ...props }) =>
  !success ? (
    <div>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M7 1.375C5.50816 1.375 4.07742 1.96763 3.02252 3.02252C1.96763 4.07742 1.375 5.50816 1.375 7C1.375 8.49184 1.96763 9.92258 3.02252 10.9775C4.07742 12.0324 5.50816 12.625 7 12.625C8.49184 12.625 9.92258 12.0324 10.9775 10.9775C12.0324 9.92258 12.625 8.49184 12.625 7C12.625 5.50816 12.0324 4.07742 10.9775 3.02252C9.92258 1.96763 8.49184 1.375 7 1.375ZM0.25 7C0.25 6.11358 0.424594 5.23583 0.763813 4.41689C1.10303 3.59794 1.60023 2.85382 2.22703 2.22703C2.85382 1.60023 3.59794 1.10303 4.41689 0.763813C5.23583 0.424594 6.11358 0.25 7 0.25C7.88642 0.25 8.76417 0.424594 9.58311 0.763813C10.4021 1.10303 11.1462 1.60023 11.773 2.22703C12.3998 2.85382 12.897 3.59794 13.2362 4.41689C13.5754 5.23583 13.75 6.11358 13.75 7C13.75 8.79021 13.0388 10.5071 11.773 11.773C10.5071 13.0388 8.79021 13.75 7 13.75C5.20979 13.75 3.4929 13.0388 2.22703 11.773C0.961159 10.5071 0.25 8.79021 0.25 7Z"
          fill="black"
        />
      </svg>
    </div>
  ) : (
    <div style={{marginTop:"-2px"}} className="w-18px h-18px">
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 20 20"
        fill="none"
      >
        <circle cx="10" cy="10" r="10" fill="#00CD34" />
        <path
          d="M8.63178 12.84L6.10547 10.3317L6.98968 9.45371L8.63178 11.0842L12.8002 6.94531L13.6844 7.82325L8.63178 12.84Z"
          fill="white"
        />
      </svg>
    </div>
  );

const tick = ({ onClick = () => {}, ...props }) => (
  <div className="w-20px h-20px">
    <svg
      {...props}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="10" fill="#00CD34" />
      <path
        d="M8.63178 12.84L6.10547 10.3317L6.98968 9.45371L8.63178 11.0842L12.8002 6.94531L13.6844 7.82325L8.63178 12.84Z"
        fill="white"
      />
    </svg>
  </div>
);

const tooltip = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_8815_2089)">
      <path
        d="M9.96088 7.38954C10.3904 7.38954 10.7387 7.04132 10.7387 6.61176C10.7387 6.18221 10.3904 5.83398 9.96088 5.83398C9.53133 5.83398 9.18311 6.18221 9.18311 6.61176C9.18311 7.04132 9.53133 7.38954 9.96088 7.38954Z"
        fill="#7A7A7A"
      />
      <path
        d="M11.6667 12.7784H10.5556V8.33398H8.88894C8.7416 8.33398 8.60029 8.39252 8.49611 8.4967C8.39192 8.60089 8.33339 8.7422 8.33339 8.88954C8.33339 9.03688 8.39192 9.17819 8.49611 9.28238C8.60029 9.38656 8.7416 9.4451 8.88894 9.4451H9.4445V12.7784H8.33339C8.18605 12.7784 8.04474 12.837 7.94055 12.9411C7.83636 13.0453 7.77783 13.1866 7.77783 13.334C7.77783 13.4813 7.83636 13.6226 7.94055 13.7268C8.04474 13.831 8.18605 13.8895 8.33339 13.8895H11.6667C11.8141 13.8895 11.9554 13.831 12.0596 13.7268C12.1637 13.6226 12.2223 13.4813 12.2223 13.334C12.2223 13.1866 12.1637 13.0453 12.0596 12.9411C11.9554 12.837 11.8141 12.7784 11.6667 12.7784Z"
        fill="#7A7A7A"
      />
      <path
        d="M9.99992 3.33398C8.68138 3.33398 7.39245 3.72498 6.29612 4.45752C5.19979 5.19006 4.34531 6.23125 3.84072 7.44943C3.33614 8.6676 3.20412 10.008 3.46135 11.3013C3.71859 12.5945 4.35353 13.7823 5.28588 14.7147C6.21823 15.647 7.40611 16.282 8.69932 16.5392C9.99253 16.7965 11.333 16.6644 12.5511 16.1598C13.7693 15.6553 14.8105 14.8008 15.5431 13.7045C16.2756 12.6081 16.6666 11.3192 16.6666 10.0007C16.6666 8.23254 15.9642 6.53685 14.714 5.28661C13.4637 4.03636 11.768 3.33398 9.99992 3.33398ZM9.99992 15.5562C8.90114 15.5562 7.82703 15.2304 6.91342 14.6199C5.99981 14.0095 5.28774 13.1418 4.86726 12.1267C4.44677 11.1115 4.33675 9.99449 4.55111 8.91682C4.76548 7.83914 5.29459 6.84924 6.07155 6.07228C6.84851 5.29532 7.83841 4.76621 8.91609 4.55184C9.99376 4.33748 11.1108 4.4475 12.1259 4.86799C13.1411 5.28847 14.0087 6.00054 14.6192 6.91415C15.2296 7.82776 15.5555 8.90187 15.5555 10.0007C15.5555 10.7302 15.4118 11.4526 15.1326 12.1267C14.8534 12.8007 14.4442 13.4131 13.9283 13.929C13.4124 14.4449 12.8 14.8541 12.1259 15.1333C11.4519 15.4125 10.7295 15.5562 9.99992 15.5562Z"
        fill="#7A7A7A"
      />
    </g>
    <defs>
      <clipPath id="clip0_8815_2089">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const google = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_8518_9966)">
      <path
        d="M8.36055 0.789921C5.96258 1.6218 3.89457 3.20073 2.46029 5.2948C1.026 7.38887 0.301037 9.88769 0.391883 12.4242C0.482728 14.9608 1.38459 17.4013 2.96501 19.3874C4.54543 21.3735 6.72109 22.8005 9.17243 23.4587C11.1598 23.9715 13.2419 23.994 15.2399 23.5243C17.0499 23.1177 18.7233 22.2481 20.0962 21.0005C21.5251 19.6624 22.5622 17.9602 23.0962 16.0768C23.6765 14.0287 23.7798 11.8748 23.3981 9.78055H12.2381V14.4099H18.7012C18.572 15.1483 18.2952 15.853 17.8873 16.4819C17.4795 17.1107 16.9489 17.6509 16.3274 18.0699C15.5382 18.592 14.6485 18.9432 13.7156 19.1012C12.7798 19.2752 11.82 19.2752 10.8843 19.1012C9.93591 18.9051 9.03874 18.5137 8.24993 17.9518C6.98271 17.0548 6.0312 15.7804 5.53118 14.3105C5.02271 12.8132 5.02271 11.1898 5.53118 9.69242C5.8871 8.64283 6.47549 7.68717 7.25243 6.8968C8.14154 5.9757 9.26718 5.31729 10.5058 4.99381C11.7445 4.67034 13.0484 4.69429 14.2743 5.06305C15.232 5.35703 16.1078 5.87068 16.8318 6.56305C17.5606 5.83805 18.2881 5.11117 19.0143 4.38242C19.3893 3.99055 19.7981 3.61742 20.1674 3.21617C19.0622 2.18769 17.765 1.3874 16.3499 0.861171C13.7731 -0.0744733 10.9536 -0.0996178 8.36055 0.789921Z"
        fill="white"
      />
      <path
        d="M8.3607 0.788879C10.9536 -0.101264 13.7731 -0.0767817 16.3501 0.858254C17.7654 1.38806 19.062 2.1922 20.1657 3.2245C19.7907 3.62575 19.3951 4.00075 19.0126 4.39075C18.2851 5.117 17.5582 5.84075 16.832 6.562C16.1079 5.86964 15.2321 5.35599 14.2745 5.062C13.0489 4.69196 11.7451 4.66662 10.5061 4.98877C9.26712 5.31092 8.14079 5.96812 7.2507 6.88825C6.47377 7.67863 5.88538 8.63428 5.52945 9.68388L1.64258 6.6745C3.03384 3.91556 5.44273 1.80517 8.3607 0.788879Z"
        fill="#E33629"
      />
      <path
        d="M0.611157 9.65703C0.820072 8.62164 1.16691 7.61896 1.64241 6.67578L5.52928 9.69266C5.02081 11.19 5.02081 12.8134 5.52928 14.3108C4.23428 15.3108 2.93866 16.3158 1.64241 17.3258C0.452064 14.9564 0.0890305 12.2567 0.611157 9.65703Z"
        fill="#F8BD00"
      />
      <path
        d="M12.2381 9.77734H23.3981C23.7799 11.8716 23.6766 14.0255 23.0963 16.0736C22.5623 17.957 21.5252 19.6592 20.0963 20.9973C18.8419 20.0186 17.5819 19.0473 16.3275 18.0686C16.9494 17.6491 17.4802 17.1084 17.8881 16.4788C18.296 15.8493 18.5726 15.1439 18.7013 14.4048H12.2381C12.2363 12.8636 12.2381 11.3205 12.2381 9.77734Z"
        fill="#587DBD"
      />
      <path
        d="M1.64062 17.3255C2.93688 16.3255 4.2325 15.3205 5.5275 14.3105C6.02851 15.7809 6.98138 17.0553 8.25 17.9518C9.04126 18.511 9.94037 18.8993 10.89 19.0918C11.8257 19.2658 12.7855 19.2658 13.7213 19.0918C14.6542 18.9339 15.5439 18.5826 16.3331 18.0605C17.5875 19.0393 18.8475 20.0105 20.1019 20.9893C18.7292 22.2375 17.0558 23.1078 15.2456 23.5149C13.2476 23.9846 11.1655 23.9621 9.17813 23.4493C7.60632 23.0296 6.13814 22.2898 4.86563 21.2762C3.51874 20.2068 2.41867 18.8592 1.64062 17.3255Z"
        fill="#319F43"
      />
    </g>
    <defs>
      <clipPath id="clip0_8518_9966">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const cross = () => (
  <div className="w-20px h-20px">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="10" fill="#FF170A" />
      <path
        d="M12.351 7.43948L7.43848 12.352M12.351 12.352L7.43848 7.43945"
        stroke="white"
        strokeWidth="1.59826"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
const modalCross = ({ fill = "#28303F", ...props }) => (
  <svg
    {...props}
    className="cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.2427 7.75786L7.75745 16.2431M16.2427 16.2431L7.75745 7.75781"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const tempWeather = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={313}
    height={96}
    viewBox="0 0 313 96"
    fill="none"
  >
    <path
      d="M213.148 90.384L211.096 87.432C210.536 86.624 210.104 85.996 209.8 85.548L209.776 85.56C209.784 86.024 209.788 86.764 209.788 87.78V93H209.08V84.312H209.788L213.16 89.16L216.532 84.312H217.24V93H216.508V87.78C216.508 86.764 216.512 86.024 216.52 85.56L216.496 85.548C216.192 85.996 215.76 86.624 215.2 87.432L213.148 90.384ZM219.788 92.244C219.212 91.652 218.924 90.92 218.924 90.048C218.924 89.176 219.212 88.444 219.788 87.852C220.372 87.26 221.104 86.964 221.984 86.964C222.864 86.964 223.592 87.26 224.168 87.852C224.752 88.444 225.044 89.176 225.044 90.048C225.044 90.92 224.752 91.652 224.168 92.244C223.592 92.836 222.864 93.132 221.984 93.132C221.104 93.132 220.372 92.836 219.788 92.244ZM220.304 88.308C219.856 88.772 219.632 89.352 219.632 90.048C219.632 90.744 219.856 91.324 220.304 91.788C220.752 92.252 221.312 92.484 221.984 92.484C222.656 92.484 223.216 92.252 223.664 91.788C224.112 91.324 224.336 90.744 224.336 90.048C224.336 89.352 224.112 88.772 223.664 88.308C223.216 87.844 222.656 87.612 221.984 87.612C221.312 87.612 220.752 87.844 220.304 88.308ZM227.184 92.508C226.84 92.116 226.668 91.5 226.668 90.66V87.096H227.376V90.528C227.376 91.256 227.5 91.76 227.748 92.04C228.012 92.336 228.384 92.484 228.864 92.484C229.6 92.484 230.312 92.12 231 91.392V87.096H231.708V93H231V92.16L230.976 92.148C230.288 92.804 229.54 93.132 228.732 93.132C228.068 93.132 227.552 92.924 227.184 92.508ZM233.794 93V87.096H234.502V87.924L234.526 87.936C235.23 87.288 235.986 86.964 236.794 86.964C237.426 86.964 237.93 87.164 238.306 87.564C238.658 87.94 238.834 88.528 238.834 89.328V93H238.126V89.46C238.126 88.788 238.002 88.316 237.754 88.044C237.498 87.764 237.13 87.624 236.65 87.624C235.882 87.624 235.166 87.976 234.502 88.68V93H233.794ZM241.736 92.628C241.456 92.3 241.316 91.752 241.316 90.984V87.72H240.14V87.096H241.316V85.44L242.024 85.32V87.096H243.932V87.72H242.024V90.864C242.024 91.384 242.096 91.784 242.24 92.064C242.384 92.344 242.668 92.484 243.092 92.484C243.404 92.484 243.684 92.412 243.932 92.268V92.94C243.66 93.068 243.348 93.132 242.996 93.132C242.452 93.132 242.032 92.964 241.736 92.628ZM246.932 93.132C246.364 93.132 245.9 92.996 245.54 92.724C245.132 92.42 244.928 91.996 244.928 91.452C244.928 90.868 245.176 90.412 245.672 90.084C246.08 89.82 246.62 89.688 247.292 89.688C247.772 89.688 248.28 89.76 248.816 89.904V89.22C248.816 88.652 248.672 88.24 248.384 87.984C248.096 87.736 247.692 87.612 247.172 87.612C246.492 87.612 245.888 87.804 245.36 88.188V87.48C245.92 87.128 246.548 86.952 247.244 86.952C247.956 86.952 248.516 87.124 248.924 87.468C249.324 87.804 249.524 88.332 249.524 89.052V91.608C249.524 92.192 249.724 92.484 250.124 92.484C250.268 92.484 250.396 92.452 250.508 92.388V93C250.364 93.064 250.192 93.096 249.992 93.096C249.448 93.096 249.092 92.864 248.924 92.4H248.9C248.332 92.888 247.676 93.132 246.932 93.132ZM247.028 92.496C247.684 92.496 248.28 92.264 248.816 91.8V90.468C248.32 90.324 247.832 90.252 247.352 90.252C246.872 90.252 246.468 90.344 246.14 90.528C245.812 90.704 245.648 90.992 245.648 91.392C245.648 91.752 245.78 92.028 246.044 92.22C246.308 92.404 246.636 92.496 247.028 92.496ZM252.456 84.66C252.56 84.764 252.612 84.892 252.612 85.044C252.612 85.196 252.556 85.324 252.444 85.428C252.34 85.532 252.212 85.584 252.06 85.584C251.908 85.584 251.78 85.532 251.676 85.428C251.572 85.316 251.52 85.184 251.52 85.032C251.52 84.88 251.572 84.752 251.676 84.648C251.788 84.544 251.92 84.492 252.072 84.492C252.224 84.492 252.352 84.548 252.456 84.66ZM251.712 93V87.096H252.42V93H251.712ZM254.513 93V87.096H255.221V87.924L255.245 87.936C255.949 87.288 256.705 86.964 257.513 86.964C258.145 86.964 258.649 87.164 259.025 87.564C259.377 87.94 259.553 88.528 259.553 89.328V93H258.845V89.46C258.845 88.788 258.721 88.316 258.473 88.044C258.217 87.764 257.849 87.624 257.369 87.624C256.601 87.624 255.885 87.976 255.221 88.68V93H254.513ZM268.54 89.16L270.412 84.312H271.168L267.796 93H267.064L263.668 84.312H264.46L266.356 89.184C266.716 90.104 267.076 91.044 267.436 92.004H267.46C267.724 91.284 268.084 90.336 268.54 89.16ZM273.116 84.66C273.22 84.764 273.272 84.892 273.272 85.044C273.272 85.196 273.216 85.324 273.104 85.428C273 85.532 272.872 85.584 272.72 85.584C272.568 85.584 272.44 85.532 272.336 85.428C272.232 85.316 272.18 85.184 272.18 85.032C272.18 84.88 272.232 84.752 272.336 84.648C272.448 84.544 272.58 84.492 272.732 84.492C272.884 84.492 273.012 84.548 273.116 84.66ZM272.372 93V87.096H273.08V93H272.372ZM280.249 90.24H275.437C275.493 90.928 275.749 91.476 276.205 91.884C276.661 92.292 277.241 92.496 277.945 92.496C278.641 92.496 279.301 92.268 279.925 91.812V92.58C279.333 92.948 278.657 93.132 277.897 93.132C276.985 93.132 276.229 92.848 275.629 92.28C275.037 91.704 274.741 90.96 274.741 90.048C274.741 89.152 275.021 88.416 275.581 87.84C276.149 87.256 276.841 86.964 277.657 86.964C278.401 86.964 279.021 87.216 279.517 87.72C280.021 88.216 280.273 88.888 280.273 89.736C280.273 89.88 280.265 90.048 280.249 90.24ZM277.633 87.6C277.105 87.6 276.633 87.78 276.217 88.14C275.801 88.5 275.549 89.004 275.461 89.652H279.577C279.561 88.94 279.353 88.42 278.953 88.092C278.561 87.764 278.121 87.6 277.633 87.6ZM283.104 93L281.028 87.096H281.784L282.828 90.084C283.116 90.916 283.34 91.572 283.5 92.052H283.524C283.716 91.5 283.944 90.856 284.208 90.12L285.3 87.096H285.792L286.86 90.048C287.092 90.688 287.328 91.352 287.568 92.04H287.592C287.752 91.56 287.972 90.912 288.252 90.096L289.296 87.096H290.028L287.952 93H287.244L286.2 90.12C285.936 89.384 285.72 88.768 285.552 88.272H285.528C285.32 88.88 285.1 89.504 284.868 90.144L283.836 93H283.104Z"
      fill="black"
    />
    <path
      d="M194.862 52L198.852 42.648H193.728V41.864H200.056L200.07 41.892L195.758 52H194.862ZM201.118 51.972L204.548 47.968C205.154 47.268 205.602 46.6613 205.892 46.148C206.181 45.6253 206.326 45.1027 206.326 44.58C206.326 43.9173 206.111 43.4087 205.682 43.054C205.262 42.69 204.72 42.508 204.058 42.508C203.255 42.508 202.527 42.7693 201.874 43.292V42.396C202.499 41.9387 203.246 41.71 204.114 41.71C204.991 41.71 205.719 41.962 206.298 42.466C206.886 42.9607 207.18 43.656 207.18 44.552C207.18 45.1773 207.016 45.7887 206.69 46.386C206.372 46.9833 205.887 47.6647 205.234 48.43L202.854 51.188L202.868 51.216H207.6V52H201.132L201.118 51.972Z"
      fill="black"
    />
    <path
      d="M193.45 66L191.17 58.76H191.83L193.11 62.86C193.423 63.8733 193.647 64.6067 193.78 65.06H193.8C193.993 64.4267 194.223 63.6867 194.49 62.84L195.78 58.76H196.23L197.55 62.94C197.75 63.5667 197.97 64.2733 198.21 65.06H198.23C198.423 64.4133 198.637 63.7133 198.87 62.96L200.18 58.76H200.8L198.53 66H197.9L196.58 61.82C196.367 61.1467 196.177 60.53 196.01 59.97H195.99C195.823 60.55 195.637 61.1567 195.43 61.79L194.1 66H193.45ZM205.485 63.7H201.475C201.521 64.2733 201.735 64.73 202.115 65.07C202.495 65.41 202.978 65.58 203.565 65.58C204.145 65.58 204.695 65.39 205.215 65.01V65.65C204.721 65.9567 204.158 66.11 203.525 66.11C202.765 66.11 202.135 65.8733 201.635 65.4C201.141 64.92 200.895 64.3 200.895 63.54C200.895 62.7933 201.128 62.18 201.595 61.7C202.068 61.2133 202.645 60.97 203.325 60.97C203.945 60.97 204.461 61.18 204.875 61.6C205.295 62.0133 205.505 62.5733 205.505 63.28C205.505 63.4 205.498 63.54 205.485 63.7ZM203.305 61.5C202.865 61.5 202.471 61.65 202.125 61.95C201.778 62.25 201.568 62.67 201.495 63.21H204.925C204.911 62.6167 204.738 62.1833 204.405 61.91C204.078 61.6367 203.711 61.5 203.305 61.5ZM206.559 63.63C206.559 62.8833 206.789 62.2533 207.249 61.74C207.715 61.2267 208.329 60.97 209.089 60.97C209.529 60.97 209.995 61.0867 210.489 61.32L210.509 61.31V58.36H211.099V66H210.509V65.54L210.489 65.53C210.055 65.9167 209.529 66.11 208.909 66.11C208.242 66.11 207.682 65.8833 207.229 65.43C206.782 64.97 206.559 64.37 206.559 63.63ZM207.149 63.59C207.149 64.17 207.315 64.6467 207.649 65.02C207.989 65.3933 208.439 65.58 208.999 65.58C209.592 65.58 210.095 65.3733 210.509 64.96V61.9C210.055 61.6333 209.589 61.5 209.109 61.5C208.515 61.5 208.039 61.7 207.679 62.1C207.325 62.4933 207.149 62.99 207.149 63.59Z"
      fill="black"
    />
    <path
      d="M213 22C213 28.6274 207.627 34 201 34C194.373 34 189 28.6274 189 22C189 15.3726 194.373 10 201 10C207.627 10 213 15.3726 213 22Z"
      fill="url(#paint0_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M201 33.8125C207.524 33.8125 212.812 28.5239 212.812 22C212.812 15.4761 207.524 10.1875 201 10.1875C194.476 10.1875 189.188 15.4761 189.188 22C189.188 28.5239 194.476 33.8125 201 33.8125ZM201 34C207.627 34 213 28.6274 213 22C213 15.3726 207.627 10 201 10C194.373 10 189 15.3726 189 22C189 28.6274 194.373 34 201 34Z"
      fill="url(#paint1_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M242.862 52L246.852 42.648H241.728V41.864H248.056L248.07 41.892L243.758 52H242.862ZM249.118 51.972L252.548 47.968C253.154 47.268 253.602 46.6613 253.892 46.148C254.181 45.6253 254.326 45.1027 254.326 44.58C254.326 43.9173 254.111 43.4087 253.682 43.054C253.262 42.69 252.72 42.508 252.058 42.508C251.255 42.508 250.527 42.7693 249.874 43.292V42.396C250.499 41.9387 251.246 41.71 252.114 41.71C252.991 41.71 253.719 41.962 254.298 42.466C254.886 42.9607 255.18 43.656 255.18 44.552C255.18 45.1773 255.016 45.7887 254.69 46.386C254.372 46.9833 253.887 47.6647 253.234 48.43L250.854 51.188L250.868 51.216H255.6V52H249.132L249.118 51.972Z"
      fill="black"
    />
    <path
      d="M242.79 66V59.32H240.3V58.76H245.89V59.32H243.4V66H242.79ZM247.061 66V58.36H247.651V61.77L247.671 61.78C248.245 61.24 248.875 60.97 249.561 60.97C250.088 60.97 250.508 61.1367 250.821 61.47C251.115 61.7833 251.261 62.2733 251.261 62.94V66H250.671V63.05C250.671 62.4833 250.565 62.09 250.351 61.87C250.138 61.6367 249.841 61.52 249.461 61.52C248.821 61.52 248.218 61.8133 247.651 62.4V66H247.061ZM253.38 65.59C253.093 65.2633 252.95 64.75 252.95 64.05V61.08H253.54V63.94C253.54 64.5467 253.643 64.9667 253.85 65.2C254.07 65.4467 254.38 65.57 254.78 65.57C255.393 65.57 255.986 65.2667 256.56 64.66V61.08H257.15V66H256.56V65.3L256.54 65.29C255.966 65.8367 255.343 66.11 254.67 66.11C254.116 66.11 253.686 65.9367 253.38 65.59Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M261 23.767C259.578 24.5209 257.957 24.9479 256.236 24.9479C250.611 24.9479 246.052 20.3886 246.052 14.7644C246.052 13.0431 246.479 11.4216 247.233 10C241.439 10.8845 237 15.8892 237 21.9306C237 28.5963 242.404 34 249.069 34C255.111 34 260.115 29.5612 261 23.767Z"
      fill="url(#paint2_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M260.752 24.1043C259.386 24.7657 257.854 25.1365 256.236 25.1365C250.507 25.1365 245.863 20.4928 245.863 14.7644C245.863 13.1459 246.234 11.6136 246.896 10.2481C241.372 11.2692 237.189 16.1115 237.189 21.9306C237.189 28.4922 242.508 33.8114 249.069 33.8114C254.888 33.8114 259.731 29.6278 260.752 24.1043ZM260.792 23.8742C259.421 24.5613 257.874 24.9479 256.236 24.9479C250.611 24.9479 246.052 20.3886 246.052 14.7644C246.052 13.1265 246.439 11.5789 247.126 10.2079C247.161 10.1382 247.196 10.0688 247.233 10C247.155 10.0119 247.078 10.0245 247.001 10.0378C241.321 11.0189 237 15.9702 237 21.9306C237 28.5963 242.404 34 249.069 34C255.03 34 259.981 29.6795 260.962 23.9994C260.976 23.9222 260.988 23.8447 261 23.767C260.931 23.8035 260.862 23.8393 260.792 23.8742Z"
      fill="url(#paint3_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M290.862 52L294.852 42.648H289.728V41.864H296.056L296.07 41.892L291.758 52H290.862ZM297.118 51.972L300.548 47.968C301.154 47.268 301.602 46.6613 301.892 46.148C302.181 45.6253 302.326 45.1027 302.326 44.58C302.326 43.9173 302.111 43.4087 301.682 43.054C301.262 42.69 300.72 42.508 300.058 42.508C299.255 42.508 298.527 42.7693 297.874 43.292V42.396C298.499 41.9387 299.246 41.71 300.114 41.71C300.991 41.71 301.719 41.962 302.298 42.466C302.886 42.9607 303.18 43.656 303.18 44.552C303.18 45.1773 303.016 45.7887 302.69 46.386C302.372 46.9833 301.887 47.6647 301.234 48.43L298.854 51.188L298.868 51.216H303.6V52H297.132L297.118 51.972Z"
      fill="black"
    />
    <path
      d="M292.9 66V58.76H297.01V59.32H293.51V62.1H296.62V62.66H293.51V66H292.9ZM298.007 66V61.08H298.597V61.88L298.617 61.89C299.043 61.3167 299.573 61.03 300.207 61.03C300.307 61.03 300.403 61.04 300.497 61.06V61.63C300.403 61.61 300.3 61.6 300.187 61.6C299.553 61.6 299.023 61.92 298.597 62.56V66H298.007ZM302.133 59.05C302.219 59.1367 302.263 59.2433 302.263 59.37C302.263 59.4967 302.216 59.6033 302.123 59.69C302.036 59.7767 301.929 59.82 301.803 59.82C301.676 59.82 301.569 59.7767 301.483 59.69C301.396 59.5967 301.353 59.4867 301.353 59.36C301.353 59.2333 301.396 59.1267 301.483 59.04C301.576 58.9533 301.686 58.91 301.813 58.91C301.939 58.91 302.046 58.9567 302.133 59.05ZM301.513 66V61.08H302.103V66H301.513Z"
      fill="black"
    />
    <path
      d="M309.833 17C309.833 20.866 306.699 24 302.833 24C298.967 24 295.833 20.866 295.833 17C295.833 13.134 298.967 10 302.833 10C306.699 10 309.833 13.134 309.833 17Z"
      fill="url(#paint4_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M302.833 23.8906C306.639 23.8906 309.724 20.8056 309.724 17C309.724 13.1944 306.639 10.1094 302.833 10.1094C299.028 10.1094 295.943 13.1944 295.943 17C295.943 20.8056 299.028 23.8906 302.833 23.8906ZM302.833 24C306.699 24 309.833 20.866 309.833 17C309.833 13.134 306.699 10 302.833 10C298.967 10 295.833 13.134 295.833 17C295.833 20.866 298.967 24 302.833 24Z"
      fill="url(#paint5_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M283 23.9993C283 29.154 287.179 33.3327 292.333 33.3327H304.333C308.015 33.3327 311 30.3479 311 26.666C311 22.9841 308.015 19.9993 304.333 19.9993C303.166 19.9993 302.068 20.2995 301.114 20.827C299.815 17.234 296.374 14.666 292.333 14.666C287.179 14.666 283 18.8447 283 23.9993Z"
      fill="url(#paint6_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M301.023 21.0673L300.957 20.8836C299.682 17.3545 296.302 14.8327 292.333 14.8327C287.271 14.8327 283.167 18.9367 283.167 23.9993C283.167 29.062 287.271 33.166 292.333 33.166H304.333C307.923 33.166 310.833 30.2559 310.833 26.666C310.833 23.0762 307.923 20.166 304.333 20.166C303.195 20.166 302.125 20.4587 301.194 20.9728L301.023 21.0673ZM301.055 20.669C299.714 17.1589 296.315 14.666 292.333 14.666C287.179 14.666 283 18.8447 283 23.9993C283 29.154 287.179 33.3327 292.333 33.3327H304.333C308.015 33.3327 311 30.3479 311 26.666C311 22.9841 308.015 19.9993 304.333 19.9993C303.226 19.9993 302.181 20.2694 301.262 20.7474C301.212 20.7733 301.163 20.7998 301.114 20.827C301.095 20.7741 301.075 20.7214 301.055 20.669Z"
      fill="url(#paint7_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M30.08 93V84.312H32.408C33.48 84.312 34.28 84.484 34.808 84.828C35.48 85.268 35.816 85.892 35.816 86.7C35.816 87.484 35.512 88.096 34.904 88.536C34.56 88.792 34.092 88.964 33.5 89.052L36.404 93H35.516L32.684 89.112H30.812V93H30.08ZM30.812 88.488H32.636C33.492 88.488 34.124 88.32 34.532 87.984C34.9 87.672 35.084 87.256 35.084 86.736C35.084 86.144 34.848 85.692 34.376 85.38C33.976 85.116 33.304 84.984 32.36 84.984H30.812V88.488ZM42.3153 90.24H37.5033C37.5593 90.928 37.8153 91.476 38.2713 91.884C38.7273 92.292 39.3073 92.496 40.0113 92.496C40.7073 92.496 41.3673 92.268 41.9913 91.812V92.58C41.3993 92.948 40.7233 93.132 39.9633 93.132C39.0513 93.132 38.2953 92.848 37.6953 92.28C37.1033 91.704 36.8073 90.96 36.8073 90.048C36.8073 89.152 37.0873 88.416 37.6473 87.84C38.2153 87.256 38.9073 86.964 39.7233 86.964C40.4673 86.964 41.0873 87.216 41.5833 87.72C42.0873 88.216 42.3393 88.888 42.3393 89.736C42.3393 89.88 42.3313 90.048 42.3153 90.24ZM39.6993 87.6C39.1713 87.6 38.6993 87.78 38.2833 88.14C37.8673 88.5 37.6153 89.004 37.5273 89.652H41.6433C41.6273 88.94 41.4193 88.42 41.0193 88.092C40.6273 87.764 40.1873 87.6 39.6993 87.6ZM43.6042 90.156C43.6042 89.26 43.8802 88.504 44.4322 87.888C44.9922 87.272 45.7282 86.964 46.6402 86.964C47.1682 86.964 47.7282 87.104 48.3202 87.384L48.3442 87.372V83.832H49.0522V93H48.3442V92.448L48.3202 92.436C47.8002 92.9 47.1682 93.132 46.4242 93.132C45.6242 93.132 44.9522 92.86 44.4082 92.316C43.8722 91.764 43.6042 91.044 43.6042 90.156ZM44.3122 90.108C44.3122 90.804 44.5122 91.376 44.9122 91.824C45.3202 92.272 45.8602 92.496 46.5322 92.496C47.2442 92.496 47.8482 92.248 48.3442 91.752V88.08C47.8002 87.76 47.2402 87.6 46.6642 87.6C45.9522 87.6 45.3802 87.84 44.9482 88.32C44.5242 88.792 44.3122 89.388 44.3122 90.108ZM52.5298 93L50.4538 87.096H51.2098L52.2538 90.084C52.5418 90.916 52.7658 91.572 52.9258 92.052H52.9498C53.1418 91.5 53.3698 90.856 53.6338 90.12L54.7258 87.096H55.2178L56.2858 90.048C56.5178 90.688 56.7538 91.352 56.9938 92.04H57.0178C57.1778 91.56 57.3978 90.912 57.6778 90.096L58.7218 87.096H59.4538L57.3778 93H56.6698L55.6258 90.12C55.3618 89.384 55.1458 88.768 54.9778 88.272H54.9538C54.7458 88.88 54.5258 89.504 54.2938 90.144L53.2617 93H52.5298ZM60.9913 92.244C60.4153 91.652 60.1273 90.92 60.1273 90.048C60.1273 89.176 60.4153 88.444 60.9913 87.852C61.5753 87.26 62.3073 86.964 63.1873 86.964C64.0673 86.964 64.7953 87.26 65.3713 87.852C65.9553 88.444 66.2473 89.176 66.2473 90.048C66.2473 90.92 65.9553 91.652 65.3713 92.244C64.7953 92.836 64.0673 93.132 63.1873 93.132C62.3073 93.132 61.5753 92.836 60.9913 92.244ZM61.5073 88.308C61.0593 88.772 60.8353 89.352 60.8353 90.048C60.8353 90.744 61.0593 91.324 61.5073 91.788C61.9553 92.252 62.5153 92.484 63.1873 92.484C63.8593 92.484 64.4193 92.252 64.8673 91.788C65.3153 91.324 65.5393 90.744 65.5393 90.048C65.5393 89.352 65.3153 88.772 64.8673 88.308C64.4193 87.844 63.8593 87.612 63.1873 87.612C62.5153 87.612 61.9553 87.844 61.5073 88.308ZM68.3156 92.244C67.7396 91.652 67.4516 90.92 67.4516 90.048C67.4516 89.176 67.7396 88.444 68.3156 87.852C68.8996 87.26 69.6316 86.964 70.5116 86.964C71.3916 86.964 72.1196 87.26 72.6956 87.852C73.2796 88.444 73.5716 89.176 73.5716 90.048C73.5716 90.92 73.2796 91.652 72.6956 92.244C72.1196 92.836 71.3916 93.132 70.5116 93.132C69.6316 93.132 68.8996 92.836 68.3156 92.244ZM68.8316 88.308C68.3836 88.772 68.1596 89.352 68.1596 90.048C68.1596 90.744 68.3836 91.324 68.8316 91.788C69.2796 92.252 69.8396 92.484 70.5116 92.484C71.1836 92.484 71.7436 92.252 72.1916 91.788C72.6396 91.324 72.8636 90.744 72.8636 90.048C72.8636 89.352 72.6396 88.772 72.1916 88.308C71.7436 87.844 71.1836 87.612 70.5116 87.612C69.8396 87.612 69.2796 87.844 68.8316 88.308ZM74.7878 90.156C74.7878 89.26 75.0638 88.504 75.6158 87.888C76.1758 87.272 76.9118 86.964 77.8238 86.964C78.3518 86.964 78.9118 87.104 79.5038 87.384L79.5278 87.372V83.832H80.2358V93H79.5278V92.448L79.5038 92.436C78.9838 92.9 78.3518 93.132 77.6078 93.132C76.8078 93.132 76.1358 92.86 75.5918 92.316C75.0558 91.764 74.7878 91.044 74.7878 90.156ZM75.4958 90.108C75.4958 90.804 75.6958 91.376 76.0958 91.824C76.5038 92.272 77.0438 92.496 77.7158 92.496C78.4278 92.496 79.0318 92.248 79.5278 91.752V88.08C78.9838 87.76 78.4238 87.6 77.8478 87.6C77.1358 87.6 76.5638 87.84 76.1318 88.32C75.7078 88.792 75.4958 89.388 75.4958 90.108ZM84.7948 88.668C84.7948 87.404 85.2148 86.34 86.0548 85.476C86.8948 84.612 87.9828 84.18 89.3188 84.18C90.1348 84.18 90.9108 84.364 91.6468 84.732V85.548C90.9588 85.092 90.1828 84.864 89.3188 84.864C88.1988 84.864 87.2868 85.228 86.5828 85.956C85.8788 86.676 85.5268 87.576 85.5268 88.656C85.5268 89.736 85.8828 90.64 86.5948 91.368C87.3068 92.088 88.2308 92.448 89.3668 92.448C90.2708 92.448 91.0828 92.196 91.8028 91.692V92.508C91.1068 92.924 90.2828 93.132 89.3308 93.132C88.0028 93.132 86.9148 92.708 86.0668 91.86C85.2188 91.004 84.7948 89.94 84.7948 88.668ZM94.2099 84.66C94.3139 84.764 94.3659 84.892 94.3659 85.044C94.3659 85.196 94.3099 85.324 94.1979 85.428C94.0939 85.532 93.9659 85.584 93.8139 85.584C93.6619 85.584 93.5339 85.532 93.4299 85.428C93.3259 85.316 93.2739 85.184 93.2739 85.032C93.2739 84.88 93.3259 84.752 93.4299 84.648C93.5419 84.544 93.6739 84.492 93.8259 84.492C93.9779 84.492 94.1059 84.548 94.2099 84.66ZM93.4659 93V87.096H94.1739V93H93.4659ZM97.1067 92.628C96.8267 92.3 96.6867 91.752 96.6867 90.984V87.72H95.5107V87.096H96.6867V85.44L97.3947 85.32V87.096H99.3027V87.72H97.3947V90.864C97.3947 91.384 97.4667 91.784 97.6107 92.064C97.7547 92.344 98.0387 92.484 98.4627 92.484C98.7747 92.484 99.0547 92.412 99.3027 92.268V92.94C99.0307 93.068 98.7187 93.132 98.3667 93.132C97.8227 93.132 97.4027 92.964 97.1067 92.628ZM103.852 89.604L105.04 87.096H105.784L101.704 95.64H100.948L102.544 92.364L100.048 87.096H100.828L102.004 89.592C102.316 90.256 102.62 90.912 102.916 91.56H102.94C103.292 90.808 103.596 90.156 103.852 89.604Z"
      fill="black"
    />
    <path
      d="M112.862 54L116.852 44.648H111.728V43.864H118.056L118.07 43.892L113.758 54H112.862ZM119.118 53.972L122.548 49.968C123.154 49.268 123.602 48.6613 123.892 48.148C124.181 47.6253 124.326 47.1027 124.326 46.58C124.326 45.9173 124.111 45.4087 123.682 45.054C123.262 44.69 122.72 44.508 122.058 44.508C121.255 44.508 120.527 44.7693 119.874 45.292V44.396C120.499 43.9387 121.246 43.71 122.114 43.71C122.991 43.71 123.719 43.962 124.298 44.466C124.886 44.9607 125.18 45.656 125.18 46.552C125.18 47.1773 125.016 47.7887 124.69 48.386C124.372 48.9833 123.887 49.6647 123.234 50.43L120.854 53.188L120.868 53.216H125.6V54H119.132L119.118 53.972Z"
      fill="black"
    />
    <path
      d="M9.862 54L13.852 44.648H8.728V43.864H15.056L15.07 43.892L10.758 54H9.862ZM16.1176 53.972L19.5476 49.968C20.1543 49.268 20.6023 48.6613 20.8916 48.148C21.1809 47.6253 21.3256 47.1027 21.3256 46.58C21.3256 45.9173 21.1109 45.4087 20.6816 45.054C20.2616 44.69 19.7203 44.508 19.0576 44.508C18.2549 44.508 17.5269 44.7693 16.8736 45.292V44.396C17.4989 43.9387 18.2456 43.71 19.1136 43.71C19.9909 43.71 20.7189 43.962 21.2976 44.466C21.8856 44.9607 22.1796 45.656 22.1796 46.552C22.1796 47.1773 22.0163 47.7887 21.6896 48.386C21.3723 48.9833 20.8869 49.6647 20.2336 50.43L17.8536 53.188L17.8676 53.216H22.5996V54H16.1316L16.1176 53.972Z"
      fill="black"
    />
    <path
      d="M10.29 66.82L8.58 64.36C8.11333 63.6867 7.75333 63.1633 7.5 62.79L7.48 62.8C7.48667 63.1867 7.49 63.8033 7.49 64.65V69H6.9V61.76H7.49L10.3 65.8L13.11 61.76H13.7V69H13.09V64.65C13.09 63.8033 13.0933 63.1867 13.1 62.8L13.08 62.79C12.8267 63.1633 12.4667 63.6867 12 64.36L10.29 66.82ZM15.8235 68.37C15.3435 67.8767 15.1035 67.2667 15.1035 66.54C15.1035 65.8133 15.3435 65.2033 15.8235 64.71C16.3102 64.2167 16.9202 63.97 17.6535 63.97C18.3868 63.97 18.9935 64.2167 19.4735 64.71C19.9602 65.2033 20.2035 65.8133 20.2035 66.54C20.2035 67.2667 19.9602 67.8767 19.4735 68.37C18.9935 68.8633 18.3868 69.11 17.6535 69.11C16.9202 69.11 16.3102 68.8633 15.8235 68.37ZM16.2535 65.09C15.8802 65.4767 15.6935 65.96 15.6935 66.54C15.6935 67.12 15.8802 67.6033 16.2535 67.99C16.6268 68.3767 17.0935 68.57 17.6535 68.57C18.2135 68.57 18.6802 68.3767 19.0535 67.99C19.4268 67.6033 19.6135 67.12 19.6135 66.54C19.6135 65.96 19.4268 65.4767 19.0535 65.09C18.6802 64.7033 18.2135 64.51 17.6535 64.51C17.0935 64.51 16.6268 64.7033 16.2535 65.09ZM21.577 69V64.08H22.167V64.77L22.187 64.78C22.7737 64.24 23.4037 63.97 24.077 63.97C24.6037 63.97 25.0237 64.1367 25.337 64.47C25.6304 64.7833 25.777 65.2733 25.777 65.94V69H25.187V66.05C25.187 65.49 25.0837 65.0967 24.877 64.87C24.6637 64.6367 24.357 64.52 23.957 64.52C23.317 64.52 22.7204 64.8133 22.167 65.4V69H21.577Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 19.3333C2 24.488 6.17868 28.6667 11.3333 28.6667H23.3333C27.0152 28.6667 30 25.6819 30 22C30 18.3181 27.0152 15.3333 23.3333 15.3333C22.1657 15.3333 21.0681 15.6335 20.1137 16.1609C18.8153 12.5679 15.3742 10 11.3333 10C6.17868 10 2 14.1787 2 19.3333Z"
      fill="url(#paint8_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0233 16.4013L19.9569 16.2176C18.6816 12.6885 15.3018 10.1667 11.3333 10.1667C6.27072 10.1667 2.16667 14.2707 2.16667 19.3333C2.16667 24.3959 6.27072 28.5 11.3333 28.5H23.3333C26.9232 28.5 29.8333 25.5899 29.8333 22C29.8333 18.4101 26.9232 15.5 23.3333 15.5C22.1946 15.5 21.1247 15.7927 20.1943 16.3068L20.0233 16.4013ZM20.055 16.003C18.7139 12.4929 15.3147 10 11.3333 10C6.17868 10 2 14.1787 2 19.3333C2 24.488 6.17868 28.6667 11.3333 28.6667H23.3333C27.0152 28.6667 30 25.6819 30 22C30 18.3181 27.0152 15.3333 23.3333 15.3333C22.2257 15.3333 21.1812 15.6034 20.2621 16.0814C20.2123 16.1073 20.1628 16.1338 20.1137 16.1609C20.0946 16.1081 20.075 16.0554 20.055 16.003Z"
      fill="url(#paint9_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M18.3334 25.166L18.3191 29.8511C18.316 30.8594 17.6726 31.7467 16.7218 32.054C15.5018 32.4482 14.1865 31.7688 13.784 30.5365C13.4703 29.5761 13.8003 28.5268 14.6031 27.9316L18.3334 25.166Z"
      fill="url(#paint10_linear_8426_468)"
    />
    <path
      d="M8.33261 28.644H5.5L8.94372 20.5L9.05597 26.356H11.8636L8.41991 34.5L8.33261 28.644Z"
      fill="url(#paint11_linear_8426_468)"
    />
    <path
      d="M111.45 69L109.17 61.76H109.83L111.11 65.86C111.423 66.8733 111.647 67.6067 111.78 68.06H111.8C111.993 67.4267 112.223 66.6867 112.49 65.84L113.78 61.76H114.23L115.55 65.94C115.75 66.5667 115.97 67.2733 116.21 68.06H116.23C116.423 67.4133 116.637 66.7133 116.87 65.96L118.18 61.76H118.8L116.53 69H115.9L114.58 64.82C114.367 64.1467 114.177 63.53 114.01 62.97H113.99C113.823 63.55 113.637 64.1567 113.43 64.79L112.1 69H111.45ZM123.485 66.7H119.475C119.521 67.2733 119.735 67.73 120.115 68.07C120.495 68.41 120.978 68.58 121.565 68.58C122.145 68.58 122.695 68.39 123.215 68.01V68.65C122.721 68.9567 122.158 69.11 121.525 69.11C120.765 69.11 120.135 68.8733 119.635 68.4C119.141 67.92 118.895 67.3 118.895 66.54C118.895 65.7933 119.128 65.18 119.595 64.7C120.068 64.2133 120.645 63.97 121.325 63.97C121.945 63.97 122.461 64.18 122.875 64.6C123.295 65.0133 123.505 65.5733 123.505 66.28C123.505 66.4 123.498 66.54 123.485 66.7ZM121.305 64.5C120.865 64.5 120.471 64.65 120.125 64.95C119.778 65.25 119.568 65.67 119.495 66.21H122.925C122.911 65.6167 122.738 65.1833 122.405 64.91C122.078 64.6367 121.711 64.5 121.305 64.5ZM124.559 66.63C124.559 65.8833 124.789 65.2533 125.249 64.74C125.715 64.2267 126.329 63.97 127.089 63.97C127.529 63.97 127.995 64.0867 128.489 64.32L128.509 64.31V61.36H129.099V69H128.509V68.54L128.489 68.53C128.055 68.9167 127.529 69.11 126.909 69.11C126.242 69.11 125.682 68.8833 125.229 68.43C124.782 67.97 124.559 67.37 124.559 66.63ZM125.149 66.59C125.149 67.17 125.315 67.6467 125.649 68.02C125.989 68.3933 126.439 68.58 126.999 68.58C127.592 68.58 128.095 68.3733 128.509 67.96V64.9C128.055 64.6333 127.589 64.5 127.109 64.5C126.515 64.5 126.039 64.7 125.679 65.1C125.325 65.4933 125.149 65.99 125.149 66.59Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105 15.3333C105 20.488 109.179 24.6667 114.333 24.6667H126.333C130.015 24.6667 133 21.6819 133 18C133 14.3181 130.015 11.3333 126.333 11.3333C125.166 11.3333 124.068 11.6335 123.114 12.1609C121.815 8.56794 118.374 6 114.333 6C109.179 6 105 10.1787 105 15.3333Z"
      fill="url(#paint12_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.023 12.4013L122.957 12.2176C121.682 8.68851 118.302 6.16667 114.333 6.16667C109.271 6.16667 105.167 10.2707 105.167 15.3333C105.167 20.3959 109.271 24.5 114.333 24.5H126.333C129.923 24.5 132.833 21.5899 132.833 18C132.833 14.4101 129.923 11.5 126.333 11.5C125.195 11.5 124.125 11.7927 123.194 12.3068L123.023 12.4013ZM123.055 12.003C121.714 8.49293 118.315 6 114.333 6C109.179 6 105 10.1787 105 15.3333C105 20.488 109.179 24.6667 114.333 24.6667H126.333C130.015 24.6667 133 21.6819 133 18C133 14.3181 130.015 11.3333 126.333 11.3333C125.226 11.3333 124.181 11.6034 123.262 12.0814C123.212 12.1073 123.163 12.1338 123.114 12.1609C123.095 12.1081 123.075 12.0554 123.055 12.003Z"
      fill="url(#paint13_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M114.042 28.6035L114.028 32.9958C114.025 33.9411 113.422 34.7729 112.531 35.061C111.387 35.4306 110.154 34.7936 109.777 33.6383C109.483 32.7379 109.792 31.7542 110.545 31.1962L114.042 28.6035Z"
      fill="url(#paint14_linear_8426_468)"
    />
    <path
      d="M121.042 28.6035L121.028 32.9958C121.025 33.9411 120.422 34.7729 119.531 35.061C118.387 35.4306 117.154 34.7936 116.777 33.6383C116.483 32.7379 116.792 31.7542 117.545 31.1962L121.042 28.6035Z"
      fill="url(#paint15_linear_8426_468)"
    />
    <path
      d="M128.042 28.6035L128.028 32.9958C128.025 33.9411 127.422 34.7729 126.531 35.061C125.387 35.4306 124.154 34.7936 123.777 33.6383C123.483 32.7379 123.792 31.7542 124.545 31.1962L128.042 28.6035Z"
      fill="url(#paint16_linear_8426_468)"
    />
    <path
      d="M118.417 21.166L118.403 25.5583C118.4 26.5036 117.797 27.3354 116.906 27.6235C115.762 27.9931 114.529 27.3561 114.152 26.2008C113.858 25.3004 114.167 24.3167 114.92 23.7587L118.417 21.166Z"
      fill="url(#paint17_linear_8426_468)"
    />
    <path
      d="M125.417 21.166L125.403 25.5583C125.4 26.5036 124.797 27.3354 123.906 27.6235C122.762 27.9931 121.529 27.3561 121.152 26.2008C120.858 25.3004 121.167 24.3167 121.92 23.7587L125.417 21.166Z"
      fill="url(#paint18_linear_8426_468)"
    />
    <path
      d="M107.833 24.644H105L108.444 16.5L108.556 22.356H111.364L107.92 30.5L107.833 24.644Z"
      fill="url(#paint19_linear_8426_468)"
    />
    <path
      d="M58.862 54L62.852 44.648H57.728V43.864H64.056L64.07 43.892L59.758 54H58.862ZM65.1176 53.972L68.5476 49.968C69.1543 49.268 69.6023 48.6613 69.8916 48.148C70.1809 47.6253 70.3256 47.1027 70.3256 46.58C70.3256 45.9173 70.1109 45.4087 69.6816 45.054C69.2616 44.69 68.7203 44.508 68.0576 44.508C67.2549 44.508 66.5269 44.7693 65.8736 45.292V44.396C66.4989 43.9387 67.2456 43.71 68.1136 43.71C68.9909 43.71 69.7189 43.962 70.2976 44.466C70.8856 44.9607 71.1796 45.656 71.1796 46.552C71.1796 47.1773 71.0163 47.7887 70.6896 48.386C70.3723 48.9833 69.8869 49.6647 69.2336 50.43L66.8536 53.188L66.8676 53.216H71.5996V54H65.1316L65.1176 53.972Z"
      fill="black"
    />
    <path
      d="M59.79 69V62.32H57.3V61.76H62.89V62.32H60.4V69H59.79ZM63.5144 68.59C63.2277 68.2633 63.0844 67.75 63.0844 67.05V64.08H63.6744V66.94C63.6744 67.5467 63.7777 67.9667 63.9844 68.2C64.2044 68.4467 64.5144 68.57 64.9144 68.57C65.5277 68.57 66.121 68.2667 66.6944 67.66V64.08H67.2844V69H66.6944V68.3L66.6744 68.29C66.101 68.8367 65.4777 69.11 64.8044 69.11C64.251 69.11 63.821 68.9367 63.5144 68.59ZM73.2523 66.7H69.2423C69.289 67.2733 69.5023 67.73 69.8823 68.07C70.2623 68.41 70.7457 68.58 71.3323 68.58C71.9123 68.58 72.4623 68.39 72.9823 68.01V68.65C72.489 68.9567 71.9257 69.11 71.2923 69.11C70.5323 69.11 69.9023 68.8733 69.4023 68.4C68.909 67.92 68.6623 67.3 68.6623 66.54C68.6623 65.7933 68.8957 65.18 69.3623 64.7C69.8357 64.2133 70.4123 63.97 71.0923 63.97C71.7123 63.97 72.229 64.18 72.6423 64.6C73.0623 65.0133 73.2723 65.5733 73.2723 66.28C73.2723 66.4 73.2657 66.54 73.2523 66.7ZM71.0723 64.5C70.6323 64.5 70.239 64.65 69.8923 64.95C69.5457 65.25 69.3357 65.67 69.2623 66.21H72.6923C72.679 65.6167 72.5057 65.1833 72.1723 64.91C71.8457 64.6367 71.479 64.5 71.0723 64.5Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.8333 15.0307C77.004 15.4705 76.0581 15.7196 75.054 15.7196C71.7732 15.7196 69.1136 13.06 69.1136 9.77922C69.1136 8.77516 69.3627 7.82927 69.8025 7C66.4226 7.51597 63.8333 10.4354 63.8333 13.9595C63.8333 17.8479 66.9854 21 70.8737 21C74.3979 21 77.3173 18.4107 77.8333 15.0307Z"
      fill="url(#paint20_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.6885 15.2275C76.892 15.6133 75.9981 15.8296 75.054 15.8296C71.7125 15.8296 69.0036 13.1208 69.0036 9.77922C69.0036 8.83511 69.2199 7.94125 69.6058 7.14474C66.3837 7.74039 63.9433 10.565 63.9433 13.9595C63.9433 17.7871 67.0461 20.89 70.8737 20.89C74.2682 20.89 77.0929 18.4495 77.6885 15.2275ZM77.712 15.0933C76.9122 15.4941 76.0095 15.7196 75.054 15.7196C71.7732 15.7196 69.1136 13.06 69.1136 9.77922C69.1136 8.82378 69.3392 7.92103 69.74 7.1213C69.7604 7.0806 69.7812 7.04016 69.8025 7C69.7572 7.00692 69.712 7.01427 69.6669 7.02205C66.3536 7.59439 63.8333 10.4826 63.8333 13.9595C63.8333 17.8479 66.9854 21 70.8737 21C74.3506 21 77.2389 18.4797 77.8112 15.1663C77.819 15.1213 77.8263 15.0761 77.8333 15.0307C77.7931 15.052 77.7527 15.0729 77.712 15.0933Z"
      fill="url(#paint21_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 20.9993C51 26.154 55.1787 30.3327 60.3333 30.3327H72.3333C76.0152 30.3327 79 27.3479 79 23.666C79 19.9841 76.0152 16.9993 72.3333 16.9993C71.1657 16.9993 70.0681 17.2995 69.1137 17.827C67.8153 14.234 64.3742 11.666 60.3333 11.666C55.1787 11.666 51 15.8447 51 20.9993Z"
      fill="url(#paint22_linear_8426_468)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.0233 18.0673L68.9569 17.8836C67.6816 14.3545 64.3018 11.8327 60.3333 11.8327C55.2707 11.8327 51.1667 15.9367 51.1667 20.9993C51.1667 26.062 55.2707 30.166 60.3333 30.166H72.3333C75.9232 30.166 78.8333 27.2559 78.8333 23.666C78.8333 20.0762 75.9232 17.166 72.3333 17.166C71.1946 17.166 70.1247 17.4587 69.1943 17.9728L69.0233 18.0673ZM69.055 17.669C67.7139 14.1589 64.3147 11.666 60.3333 11.666C55.1787 11.666 51 15.8447 51 20.9993C51 26.154 55.1787 30.3327 60.3333 30.3327H72.3333C76.0152 30.3327 79 27.3479 79 23.666C79 19.9841 76.0152 16.9993 72.3333 16.9993C71.2257 16.9993 70.1812 17.2694 69.2621 17.7474C69.2123 17.7733 69.1628 17.7998 69.1137 17.827C69.0946 17.7741 69.075 17.7214 69.055 17.669Z"
      fill="url(#paint23_radial_8426_468)"
      fillOpacity="0.6"
    />
    <path
      d="M67.3334 26.834L67.3191 31.5191C67.316 32.5274 66.6726 33.4147 65.7218 33.722C64.5018 34.1162 63.1865 33.4368 62.784 32.2045C62.4703 31.244 62.8003 30.1948 63.6031 29.5996L67.3334 26.834Z"
      fill="url(#paint24_linear_8426_468)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8426_468"
        x1={189}
        y1={10}
        x2={213}
        y2={34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8E352" />
        <stop offset={1} stopColor="#EFB61F" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(198.563 19) rotate(80.7701) scale(15.1968)"
      >
        <stop stopColor="#E26E03" />
        <stop offset={1} stopColor="#F6DC4A" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_8426_468"
        x1={237}
        y1="10.2384"
        x2="260.762"
        y2={34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C8EFC" />
        <stop offset={1} stopColor="#6468E2" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(244.543 20.2333) rotate(72.0619) scale(14.4701)"
      >
        <stop stopColor="#A9ABFF" />
        <stop offset={1} stopColor="#6265C9" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_8426_468"
        x1="295.833"
        y1={10}
        x2="309.833"
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8E352" />
        <stop offset={1} stopColor="#EFB61F" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(301.411 15.25) rotate(80.7701) scale(8.86478)"
      >
        <stop stopColor="#E26E03" />
        <stop offset={1} stopColor="#F6DC4A" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_8426_468"
        x1={283}
        y1="14.9771"
        x2="310.708"
        y2="35.1101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8F8F8" />
        <stop offset={1} stopColor="#E5E5E5" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(295.5 27.4993) rotate(21.1048) scale(10.183 16.0882)"
      >
        <stop stopColor="#AEAEAE" />
        <stop offset={1} stopColor="#E9E9E9" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_8426_468"
        x1={2}
        y1="10.3111"
        x2="29.7085"
        y2="30.4441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8F8F8" />
        <stop offset={1} stopColor="#E5E5E5" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.5 22.8333) rotate(21.1048) scale(10.183 16.0882)"
      >
        <stop stopColor="#AEAEAE" />
        <stop offset={1} stopColor="#E9E9E9" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_8426_468"
        x1="16.4377"
        y1="24.1868"
        x2="17.4539"
        y2="33.1305"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_8426_468"
        x1="5.5"
        y1="20.5"
        x2="12.6826"
        y2="34.0664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCF3C" />
        <stop offset={1} stopColor="#FF7A00" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_8426_468"
        x1={105}
        y1="6.31111"
        x2="132.708"
        y2="26.4441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8F8F8" />
        <stop offset={1} stopColor="#E5E5E5" />
      </linearGradient>
      <radialGradient
        id="paint13_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(117.5 18.8333) rotate(21.1048) scale(10.183 16.0882)"
      >
        <stop stopColor="#AEAEAE" />
        <stop offset={1} stopColor="#E9E9E9" />
      </radialGradient>
      <linearGradient
        id="paint14_linear_8426_468"
        x1="112.265"
        y1="27.6855"
        x2="113.217"
        y2="36.0702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_8426_468"
        x1="119.265"
        y1="27.6855"
        x2="120.217"
        y2="36.0702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_8426_468"
        x1="126.265"
        y1="27.6855"
        x2="127.217"
        y2="36.0702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_8426_468"
        x1="116.64"
        y1="20.248"
        x2="117.592"
        y2="28.6327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_8426_468"
        x1="123.64"
        y1="20.248"
        x2="124.592"
        y2="28.6327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_8426_468"
        x1={105}
        y1="16.5"
        x2="112.183"
        y2="30.0664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCF3C" />
        <stop offset={1} stopColor="#FF7A00" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_8426_468"
        x1="63.8333"
        y1="7.13904"
        x2="77.6942"
        y2={21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C8EFC" />
        <stop offset={1} stopColor="#6468E2" />
      </linearGradient>
      <radialGradient
        id="paint21_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68.2336 12.9694) rotate(72.0619) scale(8.44087)"
      >
        <stop stopColor="#A9ABFF" />
        <stop offset={1} stopColor="#6265C9" />
      </radialGradient>
      <linearGradient
        id="paint22_linear_8426_468"
        x1={51}
        y1="11.9771"
        x2="78.7085"
        y2="32.1101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8F8F8" />
        <stop offset={1} stopColor="#E5E5E5" />
      </linearGradient>
      <radialGradient
        id="paint23_radial_8426_468"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(63.5 24.4993) rotate(21.1048) scale(10.183 16.0882)"
      >
        <stop stopColor="#AEAEAE" />
        <stop offset={1} stopColor="#E9E9E9" />
      </radialGradient>
      <linearGradient
        id="paint24_linear_8426_468"
        x1="65.4377"
        y1="25.8548"
        x2="66.4539"
        y2="34.7984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41AEFF" />
        <stop offset={1} stopColor="#0996FF" />
      </linearGradient>
    </defs>
  </svg>
);

const arrow = ({ rotate = 180, ...props }) => (
  <svg
    {...props}
    style={{ rotate: `${rotate}deg`, transition: "rotate 0.5s" }}
    className="cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.25 14.9997C20.2473 15.1985 20.1704 15.3891 20.0343 15.5341C19.8922 15.6749 19.7001 15.7539 19.5 15.7539C19.2998 15.7539 19.1078 15.6749 18.9656 15.5341L12 8.55906L5.03435 15.5341C4.88862 15.6537 4.70363 15.7148 4.51534 15.7055C4.32705 15.6963 4.14893 15.6173 4.01563 15.484C3.88233 15.3507 3.80338 15.1726 3.79413 14.9843C3.78488 14.796 3.846 14.611 3.9656 14.4653L11.4656 6.96531C11.6078 6.82448 11.7998 6.74547 12 6.74547C12.2001 6.74547 12.3922 6.82448 12.5343 6.96531L20.0343 14.4653C20.1704 14.6103 20.2473 14.8009 20.25 14.9997Z"
      fill="black"
    />
  </svg>
);

const email = () => (
  <div className="w-20px h-20px">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.99984 6.66667L8.15084 8.76733C9.2705 9.51378 10.7292 9.51378 11.8488 8.76733L14.9998 6.66667M4.99984 17.5H14.9998C16.8408 17.5 18.3332 16.0076 18.3332 14.1667V5.83333C18.3332 3.99238 16.8408 2.5 14.9998 2.5H4.99984C3.15889 2.5 1.6665 3.99238 1.6665 5.83333V14.1667C1.6665 16.0076 3.15889 17.5 4.99984 17.5Z"
        stroke="#F41095"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

const phone = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.5 15.8333V14.4617C17.5 13.7802 17.0851 13.1674 16.4523 12.9143L14.7572 12.2362C13.9524 11.9143 13.0352 12.263 12.6475 13.0383L12.5 13.3333C12.5 13.3333 10.4167 12.9167 8.75 11.25C7.08333 9.58333 6.66667 7.5 6.66667 7.5L6.96168 7.35249C7.73698 6.96484 8.08571 6.04761 7.76379 5.2428L7.08574 3.54768C6.83263 2.91492 6.21979 2.5 5.53828 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667C2.5 11.5305 8.46954 17.5 15.8333 17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333Z"
      stroke="#F41095"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
);

const threeDotLoader = ({ height = "16", color = "#ffff" }) => (
  <ThreeDots
    height={height}
    width="35"
    radius="9"
    color={color}
    ariaLabel="three-dots-loading"
    wrapperStyle={{}}
    wrapperClassName=""
    visible={true}
  />
);

const dollarCircle = () => (
  <div className="w-20px h-20px">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx={10} cy={10} r="9.5" fill="white" stroke="#F41095" />
      <path
        d="M11.2557 14.5914C11.5836 14.4792 11.8665 14.323 12.1026 14.1218L12.1029 14.1216C12.3479 13.9116 12.5362 13.6576 12.6675 13.3605C12.8079 13.0618 12.877 12.7256 12.877 12.354C12.877 11.9826 12.8079 11.661 12.6652 11.3931C12.525 11.1216 12.332 10.8935 12.0871 10.7094C11.853 10.5189 11.577 10.3598 11.2602 10.2314C10.9663 10.1122 10.6504 9.99696 10.3124 9.88555V5.79769C10.7333 5.80805 11.1126 5.88931 11.4516 6.03998L11.4516 6.03999L11.4532 6.04067C11.8174 6.19445 12.1103 6.41178 12.3345 6.69199L12.3954 6.76808L12.4684 6.70361L12.6821 6.51504L12.7487 6.45632L12.693 6.38719C12.4058 6.03036 12.0441 5.7732 11.6095 5.6166C11.2062 5.46346 10.7736 5.38248 10.3124 5.37294V4.57227V4.47941H10.2196H9.943H9.85014V4.57227V5.39405C9.53084 5.43195 9.23555 5.50634 8.96478 5.61783C8.67054 5.73899 8.41379 5.89973 8.19556 6.1005C7.97641 6.30211 7.80562 6.54311 7.68329 6.82255C7.55994 7.09588 7.49928 7.40236 7.49928 7.74027C7.49928 8.10954 7.55504 8.42877 7.67037 8.6949L7.67033 8.69492L7.67142 8.69725C7.79421 8.96036 7.96543 9.18861 8.18451 9.3814C8.40137 9.57224 8.65617 9.73608 8.94803 9.87343L8.94801 9.87348L8.95099 9.87476C9.22886 9.99384 9.5286 10.1053 9.85014 10.2092V14.3553C9.47618 14.3291 9.10494 14.2373 8.73608 14.0794C8.34598 13.9004 8.00459 13.6484 7.71145 13.3227L7.64994 13.2544L7.58099 13.3152L7.36727 13.5038L7.29782 13.5651L7.35893 13.6347C7.66932 13.9882 8.04028 14.2642 8.47105 14.4623L8.47168 14.4626C8.88692 14.6499 9.34678 14.7557 9.85014 14.7814V15.5848V15.6777H9.943H10.2196H10.3124V15.5848V14.78C10.6476 14.7572 10.9621 14.6945 11.2557 14.5914ZM11.2557 14.5914C11.2558 14.5914 11.256 14.5913 11.2561 14.5913L11.2253 14.5037L11.2553 14.5916C11.2555 14.5915 11.2556 14.5915 11.2557 14.5914ZM12.2354 13.181L12.2354 13.181L12.2344 13.1832C12.1225 13.4309 11.9674 13.6374 11.769 13.804C11.5684 13.9725 11.335 14.1056 11.0678 14.2027C10.8295 14.2894 10.5778 14.3407 10.3124 14.3565V10.3451C10.554 10.4256 10.7924 10.5122 11.0278 10.6049C11.2967 10.7109 11.5315 10.8447 11.733 11.0059L11.7329 11.006L11.7362 11.0084C11.9437 11.16 12.1063 11.3428 12.2253 11.5568L12.2252 11.5568L12.2265 11.559C12.3503 11.7679 12.4147 12.0272 12.4147 12.3414C12.4147 12.6561 12.3543 12.9353 12.2354 13.181ZM8.12776 6.97722L8.12777 6.97723L8.12833 6.97606C8.24051 6.7437 8.38805 6.54866 8.57078 6.38976C8.75562 6.22904 8.96472 6.10025 9.19857 6.00342C9.40974 5.919 9.62688 5.86212 9.85014 5.83272V9.73749C9.62774 9.66411 9.41136 9.58185 9.20101 9.49072C8.96568 9.38517 8.75546 9.25571 8.5699 9.10257C8.38635 8.94277 8.2389 8.75534 8.12715 8.53981C8.01832 8.32993 7.96157 8.0689 7.96157 7.75284C7.96157 7.45455 8.01795 7.19685 8.12776 6.97722Z"
        fill="#F41095"
        stroke="#F41095"
        strokeWidth="0.185714"
      />
    </svg>
  </div>
);

const minus = ({ fill = "black", disable, ...props }) => (
  <svg
    {...props}
    stroke="currentColor"
    fill={disable ? "#bfbfbf" : fill}
    strokeWidth={0}
    viewBox="0 0 24 24"
    className={`text-xl ${props.className} mr-1 text-gray-300 ${
      disable ? "cursor-not-allowed" : "cursor-pointer"
    }`}
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 11h14v2H5z" />
  </svg>
);

const plus = ({ fill = "black", disable, ...props }) => (
  <svg
    {...props}
    stroke="currentColor"
    fill={disable ? "#bfbfbf" : fill}
    strokeWidth={0}
    viewBox="0 0 24 24"
    className={`text-xl ml-1 ${props.className}  ${
      disable ? "cursor-not-allowed" : "cursor-pointer"
    }`}
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z" />
  </svg>
);

export const Profile360_icon = {
  radio,
  radio2,
  tick,
  tooltip,
  google,
  cross,
  tempWeather,
  modalCross,
  arrow,
  email,
  phone,
  threeDotLoader,
  dollarCircle,
  minus,
  plus,
};
